import React from 'react';
import theme from '../../Theme';

function MessageIcon({ className, style }) {
  const fill = theme.palette.background.default;

  return (
    <svg
      className={className}
      style={{ color: theme.palette.accent.main, ...style }}
      width={22}
      height={22}
      viewBox="0 0 28 28"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <path
        d="M4.7 23.7C4.1 24.1 3.4 24.2 2.8 23.8C2.2 23.5 1.9 22.8 2 22.1L3 17.2C2.4 15.6 2 13.8 2 12C2 5.9 7.4 1 14 1C20.6 1 26 5.9 26 12C26 18.1 20.6 23 14 23C11.8 23 9.7 22.4 7.9 21.4L4.7 23.7Z"
        fill={fill}
        stroke="currentColor"
        strokeWidth="1.8"
      />
    </svg>
  );
}

export default MessageIcon;
